module.exports = __webpack_public_path__ + "img/invoice.7de59ba2.svg";